import {Code} from "../../common/code/types";
import {CodeActionType, SetCodeAction} from "./types";

export const setCode = (code: Code): SetCodeAction => ({
    type: CodeActionType.SETCODE,
    payload: code
});